/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandSoundcloud = createReactComponent("outline", "brand-soundcloud", "IconBrandSoundcloud", [["path", { "d": "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z", "key": "svg-0" }], ["path", { "d": "M9 8l0 9", "key": "svg-1" }], ["path", { "d": "M6 17l0 -7", "key": "svg-2" }], ["path", { "d": "M3 16l0 -2", "key": "svg-3" }]]);

export { IconBrandSoundcloud as default };
//# sourceMappingURL=IconBrandSoundcloud.mjs.map
